export default __webpack_public_path__ + "static/media/consorcio.acc0941f.svg";